import { aiStudioRole } from './constants';

const routes = [
  {
    id: 'org.openedx.frontend.route.ai-studio.main',
    path: 'ai-studio/*',
    handle: {
      roles: [aiStudioRole],
    },
    async lazy() {
      const module = await import('./Main');
      return { Component: module.default };
    },
  },
];

export default routes;
